<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <span
        v-if="!(formProps.editType === 'read')"
        class="border-l-3 border-color-primary pl-10px text-18px"
        >设备设施隐患排查清单编辑</span
      >
      <div v-else>
        <el-page-header @back="$emit('cancel')" content="设备设施隐患排查清单详情"></el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="风险点基本信息" name="baseInfo">
            <el-form ref="form" disabled label-width="150px" :model="formData">
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="设备设施名称" prop="equipmentFacilityName">
                    <el-input v-model="formData.equipmentFacilityName" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="设备设施编号" prop="equipmentFacilityNo">
                    <el-input v-model="formData.equipmentFacilityNo" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="危险介质" prop="hazardousMedia">
                    <el-input v-model="formData.hazardousMedia" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="所在区域" prop="equipmentFacilityAreaStr">
                    <el-input
                      v-model="formData.equipmentFacilityAreaStr"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="管控层级" prop="controlLevel">
                    <el-input v-model="formData.controlHierarchyText" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="责任部门" prop="organizationUnitName">
                    <el-input v-model="formData.organizationUnitName" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="责任人" prop="leaderName">
                    <el-input v-model="formData.leaderName" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="风险等级" prop="riskLevelName">
                    <!-- <el-input v-model="formData.riskLevelName" show-word-limit></el-input> -->
                    <!-- 取最高等级 -->
                    <el-input :value="computerRiskLevelName" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>
        </el-collapse>
        <CheckListInfo
          :formProps="formProps"
          ref="checkListInfo"
          :dataList="rowData.equipmentFacilitySourcesDangerIdentifyAssessDtos"
        ></CheckListInfo>
      </div>
      <div class="flex justify-center mt-20px" v-if="formProps.editType !== 'read'">
        <el-button type="primary" size="small" @click="submitForm('save')" :loading="loading"
          >保存</el-button
        >
        <el-button @click="$emit('cancel')" size="small">取消</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { AbpApplicationConfigurationApi } from '@wiz-api/abp-application'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import uuid from 'uuid'
import { HiddenDangerInspectionChecklistControllApi } from '@wiz-api/double-prevention-management'
import dayjs from 'dayjs'
import { riskList } from '@/components/safety/enumField/enumTagType'
import CheckListInfo from '../business/CheckListInfo'

const hiddenDangerInspectionChecklistControllApi = new HiddenDangerInspectionChecklistControllApi()
export default {
  name: 'check-list-equip-form',
  components: {
    CheckListInfo,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  computed: {
    computerRiskLevelName() {
      const list = this.formData.equipmentFacilitySourcesDangerIdentifyAssessDtos
      return list.reduce((pre, item) => {
        if (pre.label) {
          const obj = riskList.find((i) => {
            return i.label === item.controlLevel
          })
          if (obj) {
            return obj.value > pre.label ? obj : pre
          }
          return pre
        }
        const firstObj = riskList.find((i) => {
          return i.label === item.controlLevel
        })
        return firstObj || {}
      }, {})?.label
    },
  },
  data() {
    return {
      rowData: {},
      taskList: [1, 2],
      tableData: [],
      list: [],
      loading: false,
      collapseActiveName: ['baseInfo', 'risk', 'riskLevelControl'],
    }
  },
  watch: {},
  created() {
    this.rowData = JSON.parse(JSON.stringify(this.formData))
  },
  mounted() {},

  methods: {
    async submitForm(type) {
      const data = this.$refs.checkListInfo.getData()
      if (data) {
        this.loading = true
        const form = JSON.parse(JSON.stringify(this.formData))
        // form.equipmentFacilitySourcesDangerIdentifyAssessDtos = data.map((item) => {
        //   return {
        //     ...item,
        //     deviceHiddenDangerListId: Wiz.AuthHooks.GetUserInfo().profile.sub,
        //   }
        // })
        const newData = data.map((item) => {
          const sourcesDangerRecognitionRiskAssessControlDtos = item.sourcesDangerRecognitionRiskAssessControlDtos.map(
            (i) => {
              return {
                id: i.id,
                creationTime: i.creationTime
                  ? dayjs(i.creationTime).format('YYYY-MM-DD HH:mm:ss')
                  : i.creationTime,
                creatorId: i.creatorId,
                lastModificationTime: i.lastModificationTime
                  ? dayjs(i.lastModificationTime).format('YYYY-MM-DD HH:mm:ss')
                  : i.lastModificationTime,
                lastModifierId: i.lastModifierId,
                isDeleted: i.isDeleted,
                deleterId: i.deleterId,
                deletionTime: i.deletionTime
                  ? dayjs(i.deletionTime).format('YYYY-MM-DD HH:mm:ss')
                  : i.deletionTime,
                existingControlMehtod: i.existingControlMehtod,
                controlMehtodOne: i.controlMehtodOne,
                controlMehtodTwo: i.controlMehtodTwo,
                controlMehtodThree: i.controlMehtodThree,
                suggestControlMehtod: i.suggestControlMehtod,
                sourcesDangerRecognitionPlanTaskId: i.sourcesDangerRecognitionPlanTaskId,
                recognitionRelationalId: i.recognitionRelationalId,
                tenantId: i.tenantId,
              }
            }
          )
          return {
            sourcesDangerRecognitionPlanTaskId: item.sourcesDangerRecognitionPlanTaskId,
            equipmentFacilitySourcesDangerIdentifyId: item.equipmentFacilitySourcesDangerIdentifyId,
            sourcesDangerRecognitionRiskRatingId: item.sourcesDangerRecognitionRiskRatingId,
            riskActivityRelationalId: item.riskActivityRelationalId,
            projectName: item.projectName,
            standard: item.standard,
            noComplianceStandard: item.noComplianceStandard,
            consequences: item.consequences,
            isFocusControl: item.isFocusControl,
            assetsCasualtyPredict: item.assetsCasualtyPredict,
            riskRatingMethodType: item.riskRatingMethodType,
            riskRatingStatus: item.riskRatingStatus,
            riskRatingPointsCollection: item.riskRatingPointsCollection,
            riskRatingMethodLS: item.riskRatingMethodLS,
            riskRatingMethodLEC: item.riskRatingMethodLEC,
            dRiskValue: item.dRiskValue,
            evaluationLevel: item.evaluationLevel,
            deviceHiddenDangerListId: item.deviceHiddenDangerListId,
            screeningContent: item.screeningContent,
            screeningType: item.screeningType,
            inspectionCycle: `${item.inspectionCycle}`,
            unitCycle: item.unitCycle,
            updateUser: item.updateUser,
            updateUserName: item.updateUserName,
            sourcesDangerRecognitionRiskAssessControlDtos,
          }
        })
        const [err, res] = await hiddenDangerInspectionChecklistControllApi.saveCycleData({
          body: {
            maxResultCount: 11,
            skipCount: 11,
            sorting: 'string',
            equipmentFacilityId: form.equipmentFacilityId,
            riskPointType: form.riskPointType,
            equipmentFacilityName: form.equipmentFacilityName,
            equipmentFacilityNo: form.equipmentFacilityNo,
            equipmentFacilityAreaId: form.equipmentFacilityAreaId,
            equipmentFacilityAreaStr: form.equipmentFacilityAreaStr,
            kksNo: form.kksNo,
            isSpecial: form.isSpecial,
            evaluateMethod: form.evaluateMethod,
            controlHierarchy: form.controlHierarchy,
            controlHierarchyText: form.controlHierarchyText,
            organizationUnitId: form.organizationUnitId,
            organizationUnitName: form.organizationUnitName,
            leaderId: form.leaderId,
            leaderName: form.leaderName,
            dutyPhone: form.dutyPhone,
            emergencyPhone: form.emergencyPhone,
            sourceOfRisk: form.sourceOfRisk,
            equipmentFacilitySourcesDangerIdentifyAssessDtos: newData,
          },
        })
        if (!err) {
          this.$emit('refreshList')
          this.$emit('cancel')
        }
        this.loading = false
      }
    },
    createRow() {
      // this.$refs.riskIdentify.createRow()
      this.$refs.controlMeasure.createRow()
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
</style>
